import { RefObject, useMemo } from 'react';

const rowsMap = new Map<string, RefObject<HTMLDivElement>[]>();

export const useRowsMap = () => {
    const registerCell = (itemId: string, cell: RefObject<HTMLDivElement>) => {
        const row = rowsMap.get(itemId) ?? [];
        row.push(cell);
        rowsMap.set(itemId, row);
    };

    const unregisterCell = (itemId: string, cell: RefObject<HTMLDivElement>) => {
        const row = rowsMap.get(itemId) ?? [];
        const newRow = row.filter((curCell) => curCell !== cell);
        if (newRow.length === 0) {
            rowsMap.delete(itemId);
        } else {
            rowsMap.set(itemId, newRow);
        }
    };

    return useMemo(
        () => ({
            rowsMap,
            registerCell,
            unregisterCell,
        }),
        [],
    );
};
